import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'État',
      fields: {
        room_service_visible: {
          label: 'Service en chambre/en salle visible',
        },
        has_room_service: {
          label: 'Service en chambre/en salle',
        },
      },
    },
    settings: {
      title: 'Paramètres',
      table_number: {
        label: 'Afficher le numéro de table',
      },
    },
    locations: {
      title: 'Emplacements',
    },
  },
  form: {
    google_place: {
      label: 'Nom',
      placeholder: 'Nom sur Google Maps',
    },
    type: {
      label: 'Type',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Service en chambre',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Service en salle',
      },
    },
    name: {
      label: "Nom de l'emplacement",
      placeholder: "Saisir un nom d'emplacement clair pour le client",
    },
    street_name: {
      label: 'Rue',
      placeholder: 'Nom de la rue',
    },
    street_number: {
      label: 'Numéro de rue',
      placeholder: 'Numéro de rue',
    },
    city: {
      label: 'Ville',
      placeholder: 'Ville',
    },
    zip_code: {
      label: 'Code postal',
      placeholder: 'Code postal',
    },
  },
  fields: {
    id: 'id',
    type: 'Type',
    name: 'Nom',
    address: 'Adresse',
    is_active: 'Actif',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Service en chambre',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Service en salle',
  },
  modals: {
    delete_location: {
      title: 'Êtes-vous sûr ?',
      description: "Cela supprimera l'emplacement « {{name}} »",
    },
  },
  buttons: {
    save: 'Enregistrer',
    delete: 'Supprimer',
  },
  toasts: {
    failed_to_load_locations: 'Échec du chargement des emplacements, veuillez recharger la page',
    failed_to_create_location: "Échec de la création de l'emplacement",
    failed_to_toggle_location: "Échec de la modification de la disponibilité de l'emplacement",
    failed_to_delete_location: "Échec de la suppression de l'emplacement",
    location_got_created: 'Emplacement créé avec succès',
    location_got_deleted: "L'emplacement a été supprimé",
    saving_success: 'Enregistrement réussi',
    saving_error: "Échec de l'enregistrement",
  },
};
